import React from 'react';

interface LeaveProps {
  className?: string;
  width?: number;
  height?: number;
}

const LeaveIcon = function LeaveIcon({
  className,
  width,
  height,
}: LeaveProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path d="M6 10.532C6 9.41193 6 8.85187 6.21799 8.42405C6.40973 8.04773 6.71569 7.74176 7.09202 7.55002C7.51984 7.33203 8.0799 7.33203 9.2 7.33203H22.8C23.9201 7.33203 24.4802 7.33203 24.908 7.55002C25.2843 7.74176 25.5903 8.04773 25.782 8.42405C26 8.85187 26 9.41193 26 10.532V12.6654V22.7987C26 23.9188 26 24.4789 25.782 24.9067C25.5903 25.283 25.2843 25.589 24.908 25.7807C24.4802 25.9987 23.9201 25.9987 22.8 25.9987H9.2C8.0799 25.9987 7.51984 25.9987 7.09202 25.7807C6.71569 25.589 6.40973 25.283 6.21799 24.9067C6 24.4789 6 23.9188 6 22.7987V12.6654V10.532Z" fill="#28364C" />
      <path d="M26 12.6654V10.532C26 9.41193 26 8.85187 25.782 8.42405C25.5903 8.04773 25.2843 7.74176 24.908 7.55002C24.4802 7.33203 23.9201 7.33203 22.8 7.33203H9.2C8.07989 7.33203 7.51984 7.33203 7.09202 7.55002C6.71569 7.74176 6.40973 8.04773 6.21799 8.42405C6 8.85187 6 9.41193 6 10.532V12.6654M26 12.6654V22.7987C26 23.9188 26 24.4789 25.782 24.9067C25.5903 25.283 25.2843 25.589 24.908 25.7807C24.4802 25.9987 23.9201 25.9987 22.8 25.9987H9.2C8.0799 25.9987 7.51984 25.9987 7.09202 25.7807C6.71569 25.589 6.40973 25.283 6.21799 24.9067C6 24.4789 6 23.9188 6 22.7987V12.6654M26 12.6654H6" stroke="white" />
      <path d="M11.3335 4.66797L11.3335 10.0013M20.6668 4.66797L20.6668 10.0013" stroke="#28364C" strokeLinecap="round" />
      <path d="M16 22.668L16 16.0013" stroke="white" strokeLinecap="round" />
      <path d="M19.3335 19.332L12.6668 19.332" stroke="white" strokeLinecap="round" />
    </svg>
  );
};

LeaveIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default LeaveIcon;
